import React from 'react';
import { ButtonGroup, Dropdown } from 'react-bootstrap';
import LoadingButton from '../loading_button/LoadingButton';

const FilterButtons = ({buttons, justifyContent}) => {

  return (
    <div className={`d-flex ${justifyContent} px-2`}>
      <ButtonGroup aria-label="Basic example">
        {
          buttons.map(({ func, icon, name, isDropdown, dropdownItems, isDisabled, variant, buttonType, isLoading }, index) => (
            isDropdown ? (
              <Dropdown 
                key={index} 
                className="ml-1 rounded-pill">
                <Dropdown.Toggle disabled={isDisabled} variant="light">
                  <i className="material-icons">{icon}</i> { name }
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {
                    dropdownItems.map(({dropDownItemFuc, dropdownItemName, dropDownItemValue}, index) => (
                      <Dropdown.Item  key={index} onClick={() => dropDownItemFuc(dropDownItemValue)}>{dropdownItemName}</Dropdown.Item>
                    ))
                  }
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <LoadingButton
                isLoading={isLoading}
                handleEvent={func}
                text={name}
                variant={variant}
                type={buttonType}
                disabled={isLoading}
                icon={icon} />
            )
          ))
        }
      </ButtonGroup>
    </div>
  )
}

export default FilterButtons;